import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

import { IAttendanceConfiguration } from '@shared/interfaces';

import { DateTimeFormatService } from '../../../services/date-time-format.service';
import { FlowControlService } from '../../../services/flow-control.service';
import {
  SnackbarService,
  SUCCESS_TYPES,
} from '../../../services/snackbar.service';
import { AttendanceService } from '../services/attendance.service';

@Component({
  selector: 'app-attendance-configuration',
  templateUrl: './attendance-configuration.component.html',
  styleUrls: ['./attendance-configuration.component.scss'],
})
export class AttendanceConfigurationComponent implements OnInit {
  isLoading = false;
  expandAll = false;
  panelOpenState = false;

  configurationInformationFormGroup: FormGroup;
  formattedTime: any;
  datePipe: any;

  constructor(
    route: ActivatedRoute,
    public translate: TranslateService,
    private snackbar: SnackbarService,
    private router: Router,
    private fb: FormBuilder,
    flowControlService: FlowControlService,
    private attendanceService: AttendanceService,
    private dateTimeService: DateTimeFormatService
  ) {
    this.configurationInformationFormGroup = this.fb.group({
      earliest_clockIn_time: ['', Validators.required],
      max_number_of_clockins: [
        '',
        [
          Validators.required,
          Validators.min(1),
          Validators.max(3),
          Validators.pattern('^[1-3]$'),
        ],
      ],
    });
    flowControlService.updateRouteInfo(
      router.url.split('?')[0],
      route.snapshot.data
    );
  }

  ngOnInit(): void {
    this.isLoading = true;
    this.fetchLatestAttendanceConfiguration();
    setTimeout(() => {
      this.isLoading = false;
    }, 1000);
  }
  validateClockInCount() {
    const count = this.configurationInformationFormGroup.get(
      'max_number_of_clockins'
    ).value;
    if (count > 3) {
      this.configurationInformationFormGroup
        .get('max_number_of_clockins')
        .setErrors({ exceed: true });
    } else if (count < 1) {
      this.configurationInformationFormGroup
        .get('max_number_of_clockins')
        .setErrors({ lessThan: true });
    } else {
      this.configurationInformationFormGroup
        .get('max_number_of_clockins')
        .setErrors(null);
    }
  }
  onConfigurationInfoSubmit(): void {
    if (this.configurationInformationFormGroup.valid) {
      this.isLoading = true;
      const earliestClockInTime = new Date(
        this.configurationInformationFormGroup.controls.earliest_clockIn_time.value
      );

      const attendanceConfiguration: IAttendanceConfiguration = {
        earliest_clockIn_time: earliestClockInTime,
        max_numberOf_clockIns: Number(
          this.configurationInformationFormGroup.controls.max_number_of_clockins
            .value
        ),
        is_active: true,
      };

      this.attendanceService
        .createAttendanceConfiguration(attendanceConfiguration)
        .subscribe({
          next: (response) => {
            if (response.success) {
              this.snackbar.success(
                SUCCESS_TYPES.CREATED,
                this.translate.instant(
                  'attendance.snackbar.successfull-configuration'
                )
              );
              this.router.navigate(['/app/attendance'], {
                queryParams: {
                  is_search: true,
                },
              });
            }
            this.isLoading = false;
          },
          error: () => {
            this.isLoading = false;
          },
        });
    } else {
      console.error('Form is invalid');
      this.isLoading = false;
    }
  }

  fetchLatestAttendanceConfiguration(): void {
    this.attendanceService.getLatestAttendanceConfiguration().subscribe({
      next: (response) => {
        if (response.success) {
          const latestConfiguration = response.data;
          if (!response.data) {
            console.error('Attendnace configuration has not been set up yet');
          } else {
            // Bind the time to the form control
            this.configurationInformationFormGroup.patchValue({
              earliest_clockIn_time: new Date(
                latestConfiguration.earliest_clockIn_time
              ),
              max_number_of_clockins: latestConfiguration.max_numberOf_clockIns,
            });
          }
        }
        this.isLoading = false;
      },
      error: (error) => {
        console.error('Error fetching latest attendance configuration:', error);
        this.isLoading = false;
      },
    });
  }
}
